module.exports = __webpack_public_path__ + "img/Actablue_logo.88581ee2.png";